import React from 'react';
import { WorkflowDocumentPicker } from 'src/app/workflows/WorkflowDocumentPicker';
import { ResourceAttachmentDto } from 'src/api/FiretrolApiClient';
import { useTransmittalDocumentOptions } from 'src/api/queries/transmittals/useTransmittalQueries';
import { useAttachTransmittalDocument } from 'src/api/queries/transmittals/useTransmittalMutations';

export interface ITransmittalDocumentPickerProps {
  jobId: number;
  onAttached: (attachment: ResourceAttachmentDto) => void;
}

export const TransmittalDocumentPicker: React.FC<
  ITransmittalDocumentPickerProps
> = ({ jobId, onAttached }) => {
  const { data } = useTransmittalDocumentOptions(jobId);
  const attach = useAttachTransmittalDocument();

  return (
    <WorkflowDocumentPicker
      jobId={jobId}
      onAttached={onAttached}
      options={data ?? []}
      attachFromDocument={(id, documentId) =>
        attach.mutateAsync({ jobId: id, documentId })
      }
      attaching={attach.isPending}
    />
  );
};
